import { render, staticRenderFns } from "./two_data_list.vue?vue&type=template&id=88468064&scoped=true&"
import script from "./two_data_list.vue?vue&type=script&lang=js&"
export * from "./two_data_list.vue?vue&type=script&lang=js&"
import style0 from "./two_data_list.vue?vue&type=style&index=0&id=88468064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88468064",
  null
  
)

export default component.exports